export const TOGGLE_CK_SAVING = 'toggleCkSaving';
